import PropTypes from 'prop-types';
import Replaceable from './replaceable';
import CustomPanel from './customPanel';

/**
 * @memberof module:react/propTypes
 * @typedef {Object} TemplateDefinition
 * @prop {Array} textReplaceables Properties for all text replaceables.
 * @prop {Array} mediaReplaceables Properties for all media replaceables.
 * @prop {Array} properties General properties.
 */
export default PropTypes.shape({
  textReplaceables: PropTypes.arrayOf(Replaceable),
  mediaReplaceables: PropTypes.arrayOf(Replaceable),
  customPanel: CustomPanel,
  properties: PropTypes.any
});



// WEBPACK FOOTER //
// ./app/propTypes/templateDefinition.js